export default function isDomElement(obj) {
    return obj instanceof Element;
}
